<template>
  <div
    class="left-menu-wrapper"
    v-if="
      mainPath !== 'trading' &&
      mainPath !== 'trading-chart' &&
      mainPath !== 'trading-test'
    "
  >
    <div class="left-menu-container semina">
      <div
        v-for="item in menuItems"
        :key="item.id"
        :id="item.id"
        class="menu-item"
      >
        <router-link :to="item.route">
          <div v-if="mainPath === item.path" class="active_menu">
            <img :src="item.activeIcon" />
          </div>
          <div v-else class="deactive_menu">
            <img :src="item.inactiveIcon" />
          </div>
          <div class="left-nav-name" v-html="$t(item.labelKey)"></div>
        </router-link>
      </div>
    </div>
  </div>
</template>


<script>
import { ref, computed, watch } from "vue";
import { useRoute } from "vue-router";
import "@/assets/css/left_nav.css";

export default {
  name: "LeftNav",
  setup() {
    const route = useRoute();
    const lang = ref(route.query.lang || "en");

    watch(
      () => route.query.lang,
      (newLang) => {
        lang.value = newLang || "en";
      }
    );

    const mainPath = computed(() => route.path.split("/")[1]);

    const menuItems = [
      {
        id: "dominance",
        route: "/dominance",
        path: "dominance",
        activeIcon: require("@/assets/images/left_nav/dominance_active.png"),
        inactiveIcon: require("@/assets/images/left_nav/dominance.png"),
        labelKey: "dominance.goyaDominance",
      },
      {
        id: "scorelist",
        route: "/score",
        path: "score",
        activeIcon: require("@/assets/images/left_nav/score_active.png"),
        inactiveIcon: require("@/assets/images/left_nav/score.png"),
        labelKey: "score.goyaList",
      },
      {
        id: "brieflist",
        route: "/brief",
        path: "brief",
        activeIcon: require("@/assets/images/left_nav/briefing_active.png"),
        inactiveIcon: require("@/assets/images/left_nav/briefing.png"),
        labelKey: "brief.brief",
      },
      {
        id: "analysis",
        route: "/volume",
        path: "volume",
        activeIcon: require("@/assets/images/left_nav/analysis_active.png"),
        inactiveIcon: require("@/assets/images/left_nav/analysis.png"),
        labelKey: "analysis.analysis",
      },
      // {
      //   id: "signal",
      //   route: "/signal",
      //   path: "signal",
      //   activeIcon: require("@/assets/images/left_nav/signal_active.png"),
      //   inactiveIcon: require("@/assets/images/left_nav/signal.png"),
      //   labelKey: "signal.signal",
      // },
      // {
      //   id: "clearing",
      //   route: "/clearing",
      //   path: "clearing",
      //   activeIcon: require("@/assets/images/left_nav/clearing_active.png"),
      //   inactiveIcon: require("@/assets/images/left_nav/clearing.png"),
      //   labelKey: "liq.liq",
      // },
      {
        id: "indicator",
        route: "/indicator",
        path: "indicator",
        activeIcon: require("@/assets/images/left_nav/indicator_active.png"),
        inactiveIcon: require("@/assets/images/left_nav/indicator.png"),
        labelKey: "indi.indi",
      },
      // {
      //   id: "chain",
      //   route: "/chain",
      //   path: "chain",
      //   activeIcon: require("@/assets/images/left_nav/chain_active.png"),
      //   inactiveIcon: require("@/assets/images/left_nav/chain.png"),
      //   labelKey: "chain.chain",
      // },
    ];

    return {
      lang,
      mainPath,
      menuItems,
    };
  },
};
</script>

<style></style>
